export const SEARCH_PARAMS = {
  QUERY: 'q',
  DATE: 'date',
  DATE_FROM: 'dateFrom',
  DATE_TO: 'dateTo',
  SLOT_TIME: 'slotTime',
  IS_AT_HOME: 'isAtHome',
  LATITUDE: 'lat',
  LONGITUDE: 'lng',
  ZOOM: 'zoom',
  DISPLAY_NAME: 'displayName',
  NAMED_LAT: 'namedLat',
  NAMED_LNG: 'namedLng',
  CATEGORY_ID: 'category',
  LIMIT: 'limit',
  CURSOR: 'cursor'
};
